import React from 'react';
import {
  Dialog,
  DialogSurface,
  DialogTitle,
  DialogContent,
  DialogBody,
  Button,
  Text,
  Caption1,
  Body1,
} from '@fluentui/react-components';
import {
  DismissRegular,
  PinRegular,
} from '@fluentui/react-icons';
import { NewsListItem } from '../../models/news';

interface NewsModalProps {
  isOpen: boolean;
  onClose: () => void;
  news: NewsListItem;
}

export const NewsDialog: React.FC<NewsModalProps> = ({
  isOpen,
  onClose,
  news,
}) => {
  // Format date function
  const formatDate = (dateString?: string): string => {
    if (!dateString) return '2020-01-01';
    
    try {
      const date = new Date(dateString);
      return date.toISOString().split('T')[0];
    } catch (error) {
      return '2020-01-01';
    }
  };

  // Create markup from HTML string (sanitized)
  const createMarkup = (htmlString: string) => {
    return { __html: htmlString };
  };

  return (
    <Dialog open={isOpen} onOpenChange={(event, data) => !data.open && onClose()}>
      <DialogSurface className="max-w-[700px] w-[90vw]">
        <DialogBody>
          <DialogTitle
            action={
              <Button
                appearance="subtle"
                icon={<DismissRegular />}
                onClick={onClose}
                aria-label="Close"
              />
            }
          >
            <span className="flex items-center gap-2">
              {news.header}
              {news.highlighted && (
                <PinRegular className="text-blue-600" />
              )}
            </span>
          </DialogTitle>
          <DialogContent className="overflow-y-auto max-h-[70vh]">
            <div className="flex justify-between items-center mb-6 italic">
              <Caption1>{news.subject}</Caption1>
              <Caption1>{formatDate(news.publishDate)}</Caption1>
            </div>
            <div
              dangerouslySetInnerHTML={createMarkup(news.body)}
              className='w-full rich-text-content'
            />
          </DialogContent>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
};

export default NewsDialog;
